import { NgModule } from '@angular/core';

import { PagesRoutingModule } from './pages-routing.module';
import { MainComponent } from './main/main.component';
import { AboutUsComponent } from './about-us/about-us.component';
import { JobOfferComponent } from './job-offer/job-offer.component';
import { BrandsComponent } from './brands/brands.component';
import { InlineSVGModule } from 'ng-inline-svg';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { MainButtonComponent } from '../main-layout/main-button/main-button.component';
import { ExclusiveSolutionsComponent } from './solutions/exclusive-solutions/exclusive-solutions.component';
import { FinancialSolutionsComponent } from './solutions/financial-solutions/financial-solutions.component';
import { RoadMapComponent } from './road-map/road-map.component';
import { LightboxModule } from 'ngx-lightbox';

@NgModule({
  declarations: [
    MainComponent,
    AboutUsComponent,
    MainButtonComponent,
    JobOfferComponent,
    BrandsComponent,
    ContactUsComponent,
    ExclusiveSolutionsComponent,
    FinancialSolutionsComponent,
    RoadMapComponent
  ],
  imports: [PagesRoutingModule, InlineSVGModule, LightboxModule],
  providers: []
})
export class PagesModule {}
